import errorImage from '../../assets/images/error.svg'

import Button from '../../../../commons/src/components/button'
import Grid from '../../../../commons/src/components/grid'
import GridCell from '../../../../commons/src/components/grid/GridCell'
import Headline from '../../../../commons/src/components/headline'
import Image from '../../../../commons/src/components/image'
import Modal from '../../../../commons/src/components/modal'
import Paragraph from '../../../../commons/src/components/paragraph'

type Props = {
  error: Error
}

const FatalErrorModal = ({error}: Props) => (
  <Modal
    headline={<Headline label="System error occured" size="l" />}
    buttons={<Button onClick={() => window.location.reload()}>OK</Button>}
  >
    <Grid>
      <GridCell m={3}>
        <Image src={errorImage} alt="System Error" />
      </GridCell>
      <GridCell m={9}>
        <Paragraph minor>{error.message}</Paragraph>
        <Paragraph>
          An unexpected error occured. Our technicians have been automatically warned and are
          working to fix the problem.
        </Paragraph>
        <Paragraph>Please press OK to reload the app.</Paragraph>
      </GridCell>
    </Grid>
  </Modal>
)

export default FatalErrorModal
